// components
export const onboardingLoadingConfig = [
  {
    id: '1',
    icon: 'star',
    text: 'Building your personalised action plan',
    color: 'orange',
    actions: null,
    isIgnoreProgress: true,
  },
  {
    id: '2',
    icon: 'hand-holding-heart',
    text: 'Working out your care needs',
    color: 'red',
    actions: null,
    isIgnoreProgress: true,
  },
  {
    id: '3',
    icon: 'money-bills',
    text: 'Calculating funding options',
    color: 'green',
    actions: null,
    isIgnoreProgress: true,
  },
  {
    id: '4',
    icon: 'route',
    text: 'Finalising your next steps',
    color: 'lime',
    actions: null,
    isIgnoreProgress: true,
  },
];
